module.exports = __webpack_public_path__ + "static/img/linea-etica.a90051c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/linea-etica/linea-etica.jpg
// module id = Znap
// module chunks = 0